import { type JsonDataItem } from 'types';
import { baseQuery } from '../baseQuery';

export const deleteServicePart = async ({ serviceId, partId }: JsonDataItem) => {
  const { data } = await baseQuery(`jobparts/${serviceId}/${partId}`, {
    type: 'DELETE',
  });

  return data;
};
